import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { NitroIcon, NitroSingleSelect } from 'nitro-components';
import { NumPerPageOptionContainer, SearchTypeSelector } from './ResultStyle';

import { SEARCHTYPE } from './store/TYPES';

import {
  getInputText,
  getSeletedType,
  onSelect,
  onInput,
  getUsers,
  retriveUsers
} from './store/action';

const SearchBar = ({
  total,
  tabValue,
  searchType,
  inputText,
  options,
  onSelect,
  onInput,
  fetchUsers,
  searchTerm
}) => {
  const searchUsers = () => {
    const fetchParams = {
      limit: 15,
      offset: 0,
      searchTerm,
      searchType
    };
    fetchUsers({ fetchParams: { ...fetchParams }, currentPage: 0 });
  };
  return (
    <NumPerPageOptionContainer>
      <p>
        {total} {tabValue}{' '}
      </p>
      <p>
        <strong>SEARCH</strong>
      </p>
      <SearchTypeSelector>
        <NitroSingleSelect
          value={searchType}
          options={options}
          mandatory
          bold
          action={onSelect}
        />
      </SearchTypeSelector>

      <input
        placeholder="Search"
        value={searchTerm}
        onChange={e => {
          onInput(e.target.value);
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && searchTerm) {
            console.log(searchTerm);
            searchUsers();
          }
        }}
      />
      <NitroIcon name="search" variant="primary" action={searchUsers} />
    </NumPerPageOptionContainer>
  );
};

const mapStateToProps = state => {
  const { paging } = getUsers(state);
  return {
    searchTerm: getInputText(state),
    searchType: getSeletedType(state),
    total: paging.totalRecordCount
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUsers: bindActionCreators(retriveUsers, dispatch),
  onSelect: bindActionCreators(onSelect, dispatch),
  onInput: bindActionCreators(onInput, dispatch)
});

SearchBar.propTypes = {
  searchType: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  total: PropTypes.number
};

SearchBar.defaultProps = {
  total: 0,
  searchType: 'Username',
  options: SEARCHTYPE.map(i => ({ label: i, value: i }))
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/features/userManagement/SearchBar.js